export const PeerComparison = () => {
  // TODO: [PLATFORM-5315]-[PLATFORM-5316]
  return <div data-testid="peer-comparison-panel">PeerComparison</div>;
};
